import Header from "./Components/Header";
import Visual from "./Components/Visual";
import SkillB from "./Components/SkillB";
import Mail from "./Components/Mail";
import Universe from "./Components/Universe";
import Edu from "./Components/Edu";
import Career from "./Components/Career";
import Project from "./Components/Project";
import Footer from "./Components/Footer";

import "./App.css";

function App() {
  return (
    <div className="App text-white">
      <Header />
      <main className="z-[999] w-11/12 my-0 mx-auto lg:w-full">
        <Visual />
        <Career />
        <SkillB />
        <Edu />
        <Project />
        <Mail />
        <Universe />
      </main>
      <Footer />
    </div>
  );
}

export default App;
